import { dataService } from '../../data';

import { DataObject, ObjectOptions } from "../base";
import { CreateObject } from "../item";
import { UserView, UserViewProxy } from '../views/user';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { PlaceType } from '../types';
import { EmployeeType } from '../types';
import { SessionType } from '../types';

const _schema = {
    name: "USER",
    fields: [
        { name: "status", type: "string", default: "PA" },
        { name: "email", type: "string" },
        { name: "firstname", type: "string" },
        { name: "lastname", type: "string" },
        { name: "photo", type: "file" },
        { name: "phone", type: "string" },
        { name: "lang", type: "string" },
        { name: "license", type: "boolean", "default": false },
    ],
    relate: [
        { direction: "<", target: "PLACE", by: "user", name: "place", reason: "places", child: true, class: PlaceType},
        { direction: "<", target: "STAFF", by: "user", name: "employee", reason: "employees", child: true, class: EmployeeType },
        { direction: "<", target: "SESSION", by: "user", name: "session", reason: "sessions", child: true, class: SessionType }
    ]
} as const;

const _UserClass = CreateObject(_schema);
if (!_UserClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class User extends _UserClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): User {
        return this._Copy(store) as User;
    }

    override get viewProxy(): UserView {
        return UserViewProxy(this, this.data);
    }

    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get fullname(){
        return this.firstname ? this.firstname + (this.lastname ? (' ' + this.lastname) : '') : null;
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }

    get IsActive(): boolean{
        return (this.status == 'AC');
    }

    get IsPending(){
        return (this.status == 'PA');
    }  
}

